type Option<T> = {
  value: T;
  label: string;
};

export const createEnumMapp = <T extends string>(options: Option<T>[]): Record<T, string> => {
  return options.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
  }, {} as Record<T, string>);
};

export const getEnumValues = <T extends Record<string, string>>(enumObj: T): T[keyof T][] => {
  return Object.values(enumObj) as T[keyof T][];
};

export const getEnumKeys = <T extends Record<string, string>>(enumObj: T): (keyof T)[] => {
  return Object.keys(enumObj) as (keyof T)[];
};
